import React from 'react';

const MediaSkeleton = ({ isDarkMode, layoutType = 'single', itemIndex = 0 }) => {
  // Calculate skeleton dimensions based on layout type and item position
  const getSkeletonDimensions = () => {
    switch(layoutType) {
      case 'triple':
        if (itemIndex === 0) {
          // Large image spans 2 rows - maintain aspect ratio for spanning area
          return {
            width: '100%',
            height: '100%',
            aspectRatio: 'auto' // Let grid determine size
          };
        } else {
          // Smaller images in triple layout
          return {
            width: '100%',
            height: '100%',
            aspectRatio: '1/1' // Square-ish for side items
          };
        }
      case 'single':
        return {
          width: '100%',
          height: '100%',
          aspectRatio: '16/10'
        };
      case 'dual':
        return {
          width: '100%',
          height: '100%',
          aspectRatio: '1/1'
        };
      case 'quad':
      case 'gallery':
        return {
          width: '100%',
          height: '100%',
          aspectRatio: '1/1'
        };
      default:
        return {
          width: '100%',
          height: '100%',
          aspectRatio: '1/1'
        };
    }
  };

  const dimensions = getSkeletonDimensions();
  
  const skeletonStyle = {
    width: dimensions.width,
    height: dimensions.height,
    aspectRatio: dimensions.aspectRatio,
    position: 'absolute',
    top: 0,
    left: 0,
    overflow: 'hidden',
    background: isDarkMode ? '#3a3b3c' : '#f2f3f4',
    transform: 'translateZ(0)',
    contain: 'layout'
  };

  const shimmerStyle = {
    width: '100%',
    height: '100%',
    background: `linear-gradient(90deg, ${
      isDarkMode ? '#3a3b3c 25%, #4e4f50 37%, #3a3b3c 63%' : '#f2f3f4 25%, #ffffff 37%, #f2f3f4 63%'
    })`,
    backgroundSize: '400px 100%',
    animation: 'shimmer 1.5s ease-in-out infinite',
    transform: 'translateZ(0)'
  };

  return (
    <div className="media-skeleton" style={skeletonStyle}>
      <div className="skeleton-shimmer" style={shimmerStyle} />
      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: -200px 0;
          }
          100% {
            background-position: calc(200px + 100%) 0;
          }
        }
      `}</style>
    </div>
  );
};

export default MediaSkeleton;
